import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import DensityMetadataContext from '@Pages/Heatmap/HeatmapTable/contexts/densityMetadataContext';

const calculateDensityDiameter = ({ density, isRow, densityMetadata }) => {
  const { rowsMaxDensity, colsMaxDensity, maxDensityDiameter, minDensityDiameter } = densityMetadata;
  const scale = maxDensityDiameter - minDensityDiameter;
  const cent = isRow ? scale / rowsMaxDensity : scale / colsMaxDensity;
  return density * cent + minDensityDiameter;
};

function DensityCircle({ density, isRow }) {
  const densityMetadata = useContext(DensityMetadataContext);
  const diameter = calculateDensityDiameter({ density, isRow, densityMetadata });

  const style = {
    width: diameter,
    height: diameter,
  };

  return (
    <div className="heatmap__header__density">
      <div className="heatmap__header__density__circle" style={style} />
    </div>
  );
}

DensityCircle.propTypes = {
  density: PropTypes.number.isRequired,
  isRow: PropTypes.bool,
};

export default DensityCircle;
